import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '../../actions/framework';
import { getToolOrDynamicToolName } from 'ai';
import { ok } from 'neverthrow';
import { z } from 'zod/v3';
import { ChatModel } from '../chat.model';

export class SubmitToolResultsAction extends BaseAction<
  {},
  { t: string; message?: string }[]
> {
  title = 'Approve tool call';
  description =
    'Submit pending tool results - will only submit if there are no incomplete tool calls';
  inputSchema = z.object({});
  group = 'Chat';

  applicable(context: ApplicableContext): boolean {
    const model = context.targetedModelOfType(ChatModel);

    if (!model) {
      return false;
    }

    if (
      model.hasIncompleteToolCalls() ||
      Object.keys(model.pendingToolCallResults).length === 0
    ) {
      return false;
    }

    return true;
  }

  async execute(
    _: {},
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    const model = context.targetedModelOfType(ChatModel)!;
    const pendingToolCallResults = model.pendingToolCallResults;
    const chatController = model.chatController;

    for (const toolCallId in pendingToolCallResults) {
      // Find the tool invocation in messages to get the tool name
      const toolInvocation = model.messages
        .flatMap((msg) => msg.toolInvocations?.invocations ?? [])
        .find((inv) => inv.toolCallId === toolCallId);

      if (toolInvocation) {
        // Extract tool name from the part
        const toolName = getToolOrDynamicToolName(toolInvocation as any);

        await chatController.addToolResult({
          tool: toolName,
          toolCallId,
          output: pendingToolCallResults[toolCallId],
        });
      }
    }

    model.clearPendingToolResults();

    return ok({});
  }
}
